import state from './moduleManningVesselsState.js'
import mutations from './moduleManningVesselsMutations.js'
import actions from './moduleManningVesselsActions.js'
import getters from './moduleManningVesselsGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
